import { render, staticRenderFns } from "./SuppliersBookingSettings.vue?vue&type=template&id=4ac5752a&"
import script from "./SuppliersBookingSettings.vue?vue&type=script&lang=js&"
export * from "./SuppliersBookingSettings.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersBookingSettings.vue?vue&type=style&index=0&id=4ac5752a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports